export const convertHexToRGBA = (hex: string, alpha: number) => {
  let r,
  g,
  b;
hex = hex.replace('#', '');
if (3 === hex.length) {
  r = hex.charAt(0);
  g = hex.charAt(1);
  b = hex.charAt(2);
} else if (4 === hex.length) {
  r = hex.charAt(0);
  g = hex.charAt(1);
  b = hex.charAt(2);
} else if (6 === hex.length) {
  r = hex.substring(0, 2);
  g = hex.substring(2, 4);
  b = hex.substring(4, 6);
} else if (8 === hex.length) {
  r = hex.substring(0, 2);
  g = hex.substring(2, 4);
  b = hex.substring(4, 6);
} else {
  return null;
}

if (1 === r.length) {
  r += r;
}
if (1 === g.length) {
  g += g;
}
if (1 === b.length) {
  b += b;
}

r = parseInt(r, 16);
g = parseInt(g, 16);
b = parseInt(b, 16);
return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
}